import Header from "../../components/Header/Header";
import imgUniverse from "../../assets/img_universe.png";
import iconTel2 from "../../assets/icon_tel2.svg";
import useReactGASend from "../../hooks/useReactGASend";

export const LinkItem = ({ title, url, isPhoneLink, onClick }) => (
  <li>
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-14 rounded-[30px] ${
        isPhoneLink ? "border-2" : "border"
      } border-neutral-600 text-neutral-600 font-semibold`}
    >
      {isPhoneLink && <img src={iconTel2} alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);

const UniverseClubPage = () => {
  const { makeEventTrackFn } = useReactGASend();

  const trackLinkClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="유니버스클럽" />
      <div className="rounded-[20px] overflow-hidden mb-14">
        <img src={imgUniverse} alt="유니버스클럽 이미지" />
      </div>
      <ul className="flex flex-col gap-1.5">
        <LinkItem
          title="혜택안내"
          url="https://m.shinsegaepoint.com/membership/combine"
          onClick={() => trackLinkClick("유니버스 클럽 혜택안내")}
        />
        <LinkItem
          title="이마트 앱에서 가입하기"
          url="https://universeclub.emart.com/membership/membershipGuide"
          onClick={() => trackLinkClick("유니버스 클럽 가입하기")}
        />
        <LinkItem
          title="FAQ"
          url="https://store.emart.com/faq/faq.do?goTabU="
          onClick={() => trackLinkClick("유니버스 클럽 FAQ")}
        />
        <LinkItem
          title="상담원연결"
          url="tel:02-380-5880"
          isPhoneLink
          onClick={() => trackLinkClick("유니버스 클럽 고객센터 연결")}
        />
      </ul>
    </section>
  );
};

export default UniverseClubPage;
